import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { Control, Controls, Title } from 'features/App';
import Message from 'components/Message';
import Tabs, { Tab, TabLabel } from 'components/Tabs';

import RatingsList from './RatingsList/RatingsListContainer';
import RatingsStatistics from './ReviewsStatistics/ReviewsStatisticsContainer';
import RatingsUsersFilter from './RatingsUsersFilter/RatingsUsersFilterContainer';
import RatingsClassFilter from './RatingsClassFilterContainer';
import RatingsSummary from './RatingsSummary/RatingsSummaryContainer';
import RatingsInstructorFilter from './RatingsInstructorFilterContainer';

const messages = defineMessages({
  pageTitle: {
    id: 'ratings.page.title',
    defaultMessage: 'Ratings & Reviews',
  },
  tabOverview: {
    id: 'ratings.tabs.overview',
    defaultMessage: 'Overview',
  },
  tabReviews: {
    id: 'ratings.tabs.reviews',
    defaultMessage: 'Reviews',
  },
});

const Ratings = ({ selectedTab, updateSelectedTab }) => (
  <>
    <Message message={messages.pageTitle} as={Title} />

    <Controls inline>
      <Control type="filter">
        <RatingsClassFilter />
      </Control>
      <Control type="filter">
        <RatingsInstructorFilter />
      </Control>
      <Control type="filter">
        <RatingsUsersFilter />
      </Control>
    </Controls>

    <Tabs selectedTab={selectedTab} onTabChange={updateSelectedTab}>
      <Tab name="overview">
        <TabLabel>
          <Message className="ratings__tab-label" message={messages.tabOverview} />
        </TabLabel>
        <RatingsStatistics />
        <RatingsSummary />
      </Tab>
      <Tab name="reviews">
        <TabLabel>
          <Message className="ratings__tab-label" message={messages.tabReviews} />
        </TabLabel>
        <RatingsList />
      </Tab>
    </Tabs>
  </>
);

Ratings.propTypes = {
  selectedTab: PropTypes.string,
  updateSelectedTab: PropTypes.func,
};

export default Ratings;
